import { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { ReactComponent as ArrowRightCircle } from '../assets/ArrowRightCircle.svg';

function BackToTopButton() {
  const [isVisible, setIsVisible] = useState(false);
  const { formatMessage } = useIntl();

  const toggleVisibility = () => {
    setIsVisible(window.scrollY > 400);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    const originalOverflowX = document.body.style.overflowX;
    const originalOverflowY = document.body.style.overflowY;
    document.body.style.overflowX = 'visible';
    document.body.style.overflowY = 'visible';
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      document.body.style.overflowX = originalOverflowX;
      document.body.style.overflowY = originalOverflowY;
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return isVisible ? (
    <button
      onClick={scrollToTop}
      className="back-to-top"
      type="button"
      aria-label={formatMessage({
        id: 'BackToTopButton.backToTop',
        defaultMessage: 'Scroll to top of page',
      })}
    >
      <ArrowRightCircle />
    </button>
  ) : null;
}

export default BackToTopButton;
